import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d93da6e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "statistics",
  class: "view"
}
const _hoisted_2 = {
  key: 0,
  class: "container"
}

import { ComputedRef, computed } from 'vue'

  import Statistics from '@/components/Statistics/index.vue'
  import NoWorkouts from '@/components/Workouts/NoWorkouts.vue'
  import { AUTH_USER_STORE, SPORTS_STORE } from '@/store/constants'
  import { ISport } from '@/types/sports'
  import { IUserProfile } from '@/types/user'
  import { useStore } from '@/use/useStore'

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const store = useStore()

  const authUser: ComputedRef<IUserProfile> = computed(
    () => store.getters[AUTH_USER_STORE.GETTERS.AUTH_USER_PROFILE]
  )
  const sports: ComputedRef<ISport[]> = computed(() =>
    store.getters[SPORTS_STORE.GETTERS.SPORTS].filter((sport) =>
      authUser.value.sports_list.includes(sport.id)
    )
  )

return (_ctx: any,_cache: any) => {
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(authUser).username)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_Card, null, {
            title: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('statistics.STATISTICS')), 1)
            ]),
            content: _withCtx(() => [
              _createVNode(Statistics, {
                class: _normalizeClass({ 'stats-disabled': _unref(authUser).nb_workouts === 0 }),
                user: _unref(authUser),
                sports: _unref(sports)
              }, null, 8, ["class", "user", "sports"])
            ]),
            _: 1
          }),
          (_unref(authUser).nb_workouts === 0)
            ? (_openBlock(), _createBlock(NoWorkouts, { key: 0 }))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})